<template>
  <div class="smy__card-full-box">
    <Card
      :bordered="false"
      class="smy__card-full"
    >
    <p slot="title">
      报备处理
    </p>
    <!-- 工单列表 -->
    <div class="table">
      <Table
        stripe
        ref="table"
        :loading="listLoading"
        :columns="columns"
        :data="list"
      ></Table>
    </div>
    <!-- 分页控件 -->
    <Page
      show-total
      show-sizer
      class="page"
      placement="top"
      :current="pageIndex + 1"
      :total="count"
      :page-size-opts="pageSizeOpts"
      @on-change="pageIndexChange"
      @on-page-size-change="pageSizeChange"
    ></Page>
    <Modal
    :mask-closable="false"
    :loading="modalLoading"
    v-model="visible"
    @on-ok="reportReson('resetLostForm')"
    title="报备失败">
       <Form
       label-position="right"
       ref="resetLostForm"
       :model="resetLostForm"
       :label-width="80">
        <FormItem
          label="失败原因"
          label-for="reason"
        >
          <Input
           type="reason"
           v-model="resetLostForm.reason"
           placeholder=""></Input>
        </FormItem>
      </Form>
    </Modal>
  </Card>
  </div>
</template>

<script>
import {mapState} from 'vuex'

export default {
  components: {
  },
  data () {
    return {
      editReportCurstom: false, // 报备客户
      visible: false,
      searchVisible: true, // 是否显示详细筛选条件
      modalLoading: true,
      pageSize: 10,
      pageIndex: 0,
      reportState: 1,
      listLoading: false, // 表格加载状态
      count: 0,
      list: [],
      resetLostForm: {
        reason: '',
        id: ''
      }
    }
  },
  computed: {
    ...mapState('table', [
      'columnsCheckedAll',
      'pageSizeOpts'
    ]),
    // 表格列 根据选中的列动态生成
    columns () {
      const allColumns = [
        {
          title: '操作',
          width: 200,
          align: 'center',
          fixed: 'right',
          render: (h, { row }) => {
            let upBtn = h('Button', {
              props: {
                type: 'ghost',
                size: 'small'
              },
              on: {
                click: () => {
                  this.listLoading = true
                  let url = '/customer/examine'
                  this.$http.put(url, {
                    id: row.id,
                    reportState: 2
                  }).then(res => {
                    if (res.success) {
                      let msg = '保存成功'
                      this.loadList()
                      this.$Message.success(msg)
                      this.listLoading = false
                    } else {
                      this.$Message.error(res.message)
                    }
                  })
                }
              }
            }, ['报备成功'])
            let reBtn = h('Button', {
              props: {
                type: 'ghost',
                size: 'small'
              },
              on: {
                click: () => {
                  this.visible = true
                  this.resetLostForm.id = row.id
                }
              },
              style: {
                marginLeft: '10px'
              }
            }, ['报备失败'])
            return h('span', [
              upBtn,
              reBtn
            ])
          }
        },
        {
          title: '企业名称',
          key: 'enterpriseName',
          width: 140
        },
        {
          title: 'CorpID',
          key: 'corpid',
          width: 140
        },
        {
          title: '联系人',
          key: 'name',
          width: 100
        },
        {
          title: '手机号码',
          key: 'phone',
          width: 140
        },
        {
          title: '所属地区',
          key: 'create_time',
          width: 160,
          render: (h, {row}) => {
            let address = row.provName + row.cityName
            return h('span', [address])
          }
        },
        {
          title: '所属行业',
          key: 'industryType',
          width: 140
        },
        {
          title: '代理商业务员',
          key: 'salemanName',
          width: 140
        },
        {
          title: '代理商',
          key: 'agentName',
          width: 140
        },
        {
          title: '报备申请时间',
          key: 'createTime',
          width: 140
        },
        {
          title: ' ',
          key: ' '
        }
      ]
      return allColumns
    }
  },
  methods: {
    // 加载列表数据
    loadList () {
      this.$http.all([
        this.$http.get('/customer/list', {
          params: {
            pageIndex: this.pageIndex,
            pageSize: this.pageSize,
            reportState: this.reportState
          }
        }),

        this.$http.get('/customer/count', {
          reportState: this.reportState
        })
      ]).then(this.$http.spread((res1, res2) => {
        this.list = res1.data
        this.count = res2.data
        this.listLoading = false
      }))
    },
    // 分页 每页大小 改变回调
    pageSizeChange (pageSize) {
      this.pageSize = pageSize
      this.loadList()
    },
    // 分页 页码 改变回调
    pageIndexChange (pageIndex) {
      this.pageIndex = pageIndex - 1
      this.loadList()
    },
    // 日期 改变回调
    daterangeChange (daterange, start, end) {
      if (daterange[0]) {
        this.searchForm[start] = daterange[0].replace('/', '-').replace('/', '-')
        this.searchForm[end] = daterange[1].replace('/', '-').replace('/', '-')
      } else {
        this.searchForm[start] = ''
        this.searchForm[start] = ''
      }
    },
    reportReson (val) {
      this.listLoading = true
      let url = '/customer/examine'
      this.$http.put(url, {
        id: this.resetLostForm.id,
        reportState: 3,
        reason: this.resetLostForm.reason
      }).then(res => {
        if (res.success) {
          let msg = '报备失败'
          this.$Message.success(msg)
          this.listLoading = false
          this.loadList()
        } else {
          this.$Message.error(res.message)
        }
      })
    },
    // 重置搜索框
    resetSearchForm () {
      this.searchForm = {
        keyword: '', // 快捷查询条件
        title: '',
        customName: '',
        customPhone: '',
        daterange: '',
        serviceExpireTimeStart: '',
        serviceExpireTimeEnd: '',
        orderType: '',
        state: '',
        serviceId: '',
        servicePersonalId: ''
      }
    },
    editReport () {
      this.editReportCurstom = true
    }
  },
  created () {
    this.loadList()
  }
}
</script>

<style lang="less" scoped>
.search {
  margin-bottom: 16px;
  .search-top {
    display: flex;
    justify-content: space-between;

    .search-top-left {
      display: flex;
      width: 70%;

      .search-input {
        width: 80%;

        // margin-left: 10px;
      }

      .search-button {
        margin-left: 10px;
      }
    }

    .search-top-right {
      .filter-column {
        display: flex;
        flex-direction: column;
        overflow: hidden;
      }

      .search-button {
        margin-left: 6px;
      }
    }
  }

  .search-detail {
    display: flex;
    flex-wrap: wrap;
    margin-top: 20px;
    height: 120px;
    transition: .5s;

    .search-detail-item {
      width: 24.25%;

      .search-input {
        width: 100%;
        margin-bottom: 10px;
      }

      .search-button {
        margin-right: 6px;
        margin-bottom: 10px;
      }
    }

    .search-detail-item:nth-child(2n+1),
    .search-detail-item:nth-child(4n+2) {
      margin-right: 1%;
    }
  }

  .search-detail-close {
    height: 0;
    opacity: 0;
  }
}

.page {
  margin-top: 20px;
  margin-bottom: 10px;
}
</style>



// WEBPACK FOOTER //
// src/pages/handle/reportHandle/index.vue